<template>
  <div id="dashboard" class="page h-screen bg-gray-200">
    <section class="w-12/12 mr-4 ">
      <div class="flex flex-wrap -m-4 pb-32">
        <div class="xl:w-2/3 md:w-full p-4">
          <div class="bg-white p-6 pb-16 rounded-2xl h-full">
            <article>
              <img
                src="@/assets/images/dashboard-pe.png"
                class="w-2/5 mr-10 inline float-left"
              />
              <div class="text-center">

                <img v-if="currentUser.isSecondaryBased"
          @click="openInNewTab('https://www.pescholar.com/insight/the-primary-physical-education-concept-curriculum/')"
          class="w-2/12 pt-2 pl-2"
            src="/static/images/pescholar-collab.png"
            alt=""
          /> 

          <div
          class="w-full pt-1 pl-2 text-slate-700 text-5xl uppercase font-bold">
          PE Passport</div>

                <h3
                  class="text-2xl text-gray-900 pt-2 font-medium title-font"
                  v-bind:class="setStyle()"
                >
                  Welcome {{ displayName }}
                </h3>
                <h5 class="pl-2 pt-2 float-none text-base">
                  Your dashboard for Physical Education.
                </h5>
              </div>
            </article>
          </div>
        </div>

   
        <div class="xl:w-1/3 md:w-1/2 p-4" v-if="!isContentAdmin">
          <div class="bg-white rounded-2xl h-full pt-4" >
            <template v-if="showForSchool">
      
              <h2 class="float-clear panel-header pb-6">Current unit</h2>
            <div class="px-6">
            
            <button
              v-if="hasUnit"
              @click="showUnit()"
              type="button"
              class="
                publish-button
                w-11/12
                mx-auto
                block
                py-4
                hover:bg-blue-300
              "
            >
              {{ unitDetails }}
            </button>
            <div v-else class="w-full text-center">
              <p class="mt-2 text-gray-400">No unit found</p>
            </div>

            <router-link to="/planning">
              <div
                class="
                  mt-6
                  bg-gray-300
                  text-center text-slate-700
                  p-4
                  hover:opacity-75
                "
              >
                See all units
              </div>
            </router-link>
            </div>
           
            </template>
            <template v-else>
              <div class="w-full text-center">
                 <img class="mx-auto" v-bind:src="setBrandedLogo()" />
              </div>
            </template>
          </div>
        </div>
        <div class="xl:w-1/3 md:w-1/2 p-4" v-if="showForSchool">
          <div class="bg-white p-6 rounded-2xl h-full" v-if="!isContentAdmin">
            <h3 class="panel-header">Upcoming events</h3>
            <div v-if="selectedMonthEvents.length === 0" class="w-full text-center">
              <p class="mt-2 text-gray-400">No events found</p>
            </div>
            <table class="w-full" v-else>
              <tr
                @click="showEvent(event)"
                v-for="(event, index) in selectedMonthEvents"
                :key="index"
                class="hover:bg-blue-100 cursor-pointer even:bg-gray-100"
              >
                <td>
                  <div class="opacity-75">
                    <div
                      class="
                        text-xs
                        mr-1
                        rounded-lg
                        h-3
                        w-3
                        inline-block
                        bg-opacity-50
                      "
                      :class="getProgramTypeClass(event)"
                    ></div>
                    {{ parseDate(event.start_date) }}
                  </div>
                  <h3 class="font-extrabold text-sm my-1">{{ event.title }}</h3>
                </td>
                <td>
                  <i class="fas fa-chevron-right opacity-25"></i>
                </td>
              </tr>
            </table>

            <router-link to="/events">
              <div
                class="
                  mt-6
                   bg-gray-300
                  text-center text-slate-700
                  p-4
                  hover:opacity-75
                "
              >
                See all events
              </div>
            </router-link>
          </div>
        </div>

        <div class="xl:w-2/3 md:w-full p-4" v-if="showForSchool">
          <div class="bg-white p-4 rounded-2xl h-64" v-if="!isContentAdmin">
            <assessmentChart
              :assessmentData="orderedAssessments"
              :isDashboardView="true"
            ></assessmentChart>
          </div>
        </div>

      <orgDashboard v-if="showForCompany"> </orgDashboard>

      </div>
    </section>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { eventMixin } from "@/mixins/eventMixin.js";
import { yearGroupMixin } from "@/mixins/yearGroupMixin.js";
import { ReportingService, ReportingFilter } from "@/services/reporting.service"
import { calendarYearList } from "@/assets/js/utils";


const assessmentChart = () =>
  import("@/components/charts/TheAssessmentChart.vue");
  const orgDashboard = () =>
  import("@/components/TheOrgDashboard.vue");

export default {
  name: "dashboard",
  mixins: [eventMixin, yearGroupMixin],
  computed: {
    ...mapGetters({ 
      currentUser: "currentUser",
      subjects: "subjects",
      authStatus: "authStatus"
    }),
    showForSchool() {
      return this.currentUser.isSchool;
    },
    showForCompany() {
      return this.currentUser.isSchool == false;
    },
    displayName() {
      return this.currentUser.schoolName;
    },
    displayType() {
      return this.currentUser.schoolType;
    },
    orderedAssessments() {
      return this.pupilAssessments;
    },
    isContentAdmin() {
      return this.currentUser.isContentAdmin;
    },
    courseYear() {
      return this.years
          .filter((year) => {
            return this.course.year_id === year.id;
          })
          .shift();
    },
    unitDetails() {
      if (this.course.id === undefined) {
        return "";
      } else {
       
      const year = this.courseYear
      return year != undefined ? year.name + " - " + this.course.name : ""
      }
      
    },
    hasUnit() {
      return this.course.id != undefined && this.courseYear != undefined
    }

  },
  mounted() {
    let calendarYear = calendarYearList().find((y) => y.current === true);
    var filterValue = new ReportingFilter(calendarYear);
    filterValue.tags = "";
    ReportingService.getAssessmentsWithFilter(filterValue, 1, 5000)
          .then((response) => this.pupilAssessments = response.data.data)
          .catch((err) => {
            console.log("Activities " + err);
          })
  },
  data() {
    return {
      pupilAssessments: [],
      course:
        this.$store.getters.unit != undefined
          ? this.$store.getters.unit
          : undefined,
    };
  },
  methods: {
    actionClick(type) {
      this.$router.push({ path: type });
    },
    openLink(url) {
      window.open(url, "_blank");
    },
    setStyle() {
      return "text-" + this.currentUser.schoolBackground;
    },
    showEvent(event) {
      this.$router.push({
        name: "EventView",
        params: { event: event, newAddition: false },
      });
    },
    showUnit() {
      this.$router.push({ name: "UnitView" });
      window.scrollTo(0, 0);
    },
    setBrandedLogo() {
      return (
        "https://primarypepassport.co.uk/organisations/images/web-logo-" +
        this.currentUser.schoolStyle +
        ".png"
      );
    },
    openInNewTab(url) {
      window.open(url, '_blank');
    },
  },
  components: {
    assessmentChart,
    orgDashboard
  },
};
</script>
<style lang="css" scoped>
/*****************************
 **** ARTICLES
 ***************************/

article {
  @apply m-2 flex-none rounded-lg h-40 cursor-pointer;
}

article h4 {
  @apply text-button-black opacity-75 w-2/3 float-right text-left;
}

article p {
  @apply text-base-text w-2/3 float-right;
}

.icon {
  @apply text-5xl ml-8 mt-6 mr-10 block float-left opacity-75;
}

article .content {
  @apply inline;
}

article .content h4 {
  @apply text-xl font-bold mb-2;
}

article .icon:after {
  -moz-transform: rotate(45deg);
  -webkit-transform: rotate(45deg);
  -ms-transform: rotate(45deg);
  transform: rotate(45deg);
  border-radius: 0.25rem;
  border: solid 2px;
  opacity: 0.2;
  content: "";
  display: block;
  position: absolute;
  height: 2.3em;
  left: -30px;
  top: -30px;
  width: 2.3em;
}
article:hover {
  opacity: 0.8;
}
article:hover .icon {
  opacity: 0.2;
}
</style>
